import { render, staticRenderFns } from "./main.vue?vue&type=template&id=f6847f30&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=f6847f30&prod&rel=stylesheet%2Fscss&lang=scss"
import style1 from "./main.vue?vue&type=style&index=1&id=f6847f30&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6847f30",
  null
  
)

export default component.exports